import { FormattedMessage } from 'react-intl';
import WidgetThumb from 'src/components/Widget/WidgetThumb/WidgetThumb';
import { useClientConfig } from 'src/hooks/useClientConfig';
import { useIsBubbleWidget } from 'src/hooks/useIsBubbleWidget';
import { useIsEmbedded } from 'src/hooks/useIsEmbedded';
import { useIsMobile } from 'src/hooks/useIsMobile';
import { useSidebar } from 'src/hooks/useSidebar';
import { useSourcesStore } from 'src/hooks/useSourcesStore';
import logo from 'src/static/vectors/logo-block.svg';
import { handleRemoveSources } from 'src/store/actions/sources';
import { useAppDispatch } from 'universal-scripts';
import './Header.sass';

interface HeaderProps {
	handleClose: () => void;
}

const Header = ({ handleClose }: HeaderProps) => {
	const { hasSources, hasInternetSources } = useSourcesStore();
	const isBubbleWidget = useIsBubbleWidget();
	const isEmbedded = useIsEmbedded();
	const hideHostChrome = isBubbleWidget || isEmbedded;
	const client = useClientConfig();
	const isMobile = useIsMobile();
	const { handleShowSidebar } = useSidebar();
	const dispatch = useAppDispatch();

	const handleClick = () => {
		if (isMobile) {
			handleShowSidebar();
		} else {
			dispatch(handleRemoveSources());
		}
	};

	if (hasSources || hasInternetSources) {
		return (
			<section id="source-header">
				<span tabIndex={0} role="button" onClick={handleClick} className="header-button go-back icon icon-angle-left" />
				<h2>
					<FormattedMessage id="sources.title" />
				</h2>
			</section>
		);
	}

	return (
		<header id="chat-masthead" onClick={handleClose}>
			<span tabIndex={0} role="button" className="header-button close icon icon-cross" />
			{hideHostChrome ? (
				<WidgetThumb />
			) : (
				<a target="_blank" href={client?.canonicalUrl ?? 'https://trueflag.ai'} className="logo" rel="noreferrer">
					<img className="logo" src={client?.image?.toString() ?? logo} alt="logo" />
				</a>
			)}
		</header>
	);
};

export default Header;
